module.exports = __webpack_public_path__ + "media/audio11.a355ce2a.mp3";